class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.searchModal = this.querySelector('.header-search__modal');
    this.backdrop = this.querySelector('.header-search__backdrop');

    this.searchModal?.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle?.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle?.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    const isInside = this.contains(event.target) || this.searchModal.contains(event.target);
    if (!isInside || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    // Abort any in-progress close so a quick re-open isn't left mid-transition.
    this.cancelClosing();
    event.target.closest('details').setAttribute('open', true);
    // Portal the backdrop + modal to <body> so their `position: fixed` escapes the
    // header's transformed/sticky containing block and covers the whole viewport.
    document.body.appendChild(this.backdrop);
    document.body.appendChild(this.searchModal);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    // Commit the closed (off-screen) state before adding `is-open`, otherwise the
    // browser collapses both into one frame and skips the entrance transition.
    void this.searchModal.offsetWidth;
    this.searchModal.classList.add('is-open');
    this.backdrop.classList.add('is-open');

    trapFocus(this.searchModal, this.searchModal.querySelector('input:not([type="hidden"])'));
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    // Clear any pending close from a previous call, then trigger the exit transition.
    this.cancelClosing();
    this.searchModal.classList.remove('is-open');
    this.backdrop.classList.remove('is-open');

    // With reduced motion there's no transition (and no transitionend), so finish now.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.finishClose();
      return;
    }

    // Once the exit transition ends, move the modal back inside the closed <details>.
    this.finishCloseHandler = this.finishClose.bind(this);
    this.searchModal.addEventListener('transitionend', this.finishCloseHandler);
    // Fallback so a missed transitionend can never leave the modal stuck open.
    this.closeTimeout = setTimeout(this.finishCloseHandler, 600);
  }

  // Tear down any pending close listener/timeout.
  cancelClosing() {
    clearTimeout(this.closeTimeout);
    if (this.finishCloseHandler) {
      this.searchModal.removeEventListener('transitionend', this.finishCloseHandler);
    }
  }

  finishClose(event) {
    // Only react to the modal's own transform transition, not other props or bubbling.
    if (event && (event.target !== this.searchModal || event.propertyName !== 'transform')) return;
    this.cancelClosing();
    // Move both back inside the closed <details> so native hiding resumes.
    this.detailsContainer.appendChild(this.backdrop);
    this.detailsContainer.appendChild(this.searchModal);
  }
}

customElements.define('details-modal', DetailsModal);
